import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image } from '../Image/Image';
import styles from './styles';
const TimeLeftInfo = ({ ndays, range }) => {
    const { t: text } = useTranslation();
    const repeatPeriods = [
        text('PROGRESS_CARD_REPEAT_WEEKLY'),
        text('PROGRESS_CARD_REPEAT_MONTHLY'),
        text('PROGRESS_CARD_REPEAT_YEARLY'),
    ];
    const output = range < 3
        ? text('PROGRESS_CARD_REPEAT_INFO')
            .replace('X', ndays.toString())
            .replace('RANGE', repeatPeriods[range])
        : text('PROGRESS_CARD_REPEAT_INFO').replace('X', ndays.toString());
    return (_jsxs(Box, { sx: styles.timeLeftInfo, children: [_jsx(Image, { src: '/assets/images/time-reverse.svg', altTextKey: 'reverse' }), _jsx(Typography, { variant: 'body1', color: '#051D33', children: output })] }));
};
export default TimeLeftInfo;
